exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".class-item[data-v-c429efcc]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;align-items:center}.class-link[data-v-c429efcc]{flex-grow:1}.wh-block__items[data-v-c429efcc]{margin-top:20px;width:100%}.class-item .header-menu__btn[data-v-c429efcc]{font-size:12px}", ""]);

// exports
